import { render } from "./AnnotationBalcony.vue?vue&type=template&id=3a985fba"
import script from "./AnnotationBalcony.vue?vue&type=script&lang=js"
export * from "./AnnotationBalcony.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ranjanbajracharya/Documents/Upwork/kaz/panorama/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__